import { createApp } from 'vue';
import VueTheMask from 'vue-the-mask';
import ElementPlus from 'element-plus';
import 'element-plus/lib/theme-chalk/index.css';
import 'font-awesome/css/font-awesome.css';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/style.sass';
import CustomButton from './components/Common/CustomButton/index.vue';

const app = createApp(App);
app.use(store);
app.use(router);
app.use(VueTheMask);
app.use(ElementPlus);
app.use(VueReCaptcha, { siteKey: '6LfwVo0dAAAAAC5kPUuZ5HSFuCXecJjZjExfycTY' });
app.component('CustomButton', CustomButton);
app.mount('#app');
